import { appTypeInjectionKey, queryClient } from '#shared'
import { VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query'
import 'destyle.css'
import { createApp } from 'vue'
import { appChatIdInjectionKey } from '#entities/chat'
import '#shared/ui/styles/index.css'
import { router } from './routing'
import App from './ui/app.vue'

async function main() {
  const vueQueryPluginOptions: VueQueryPluginOptions = {
    queryClient,
    queryClientConfig: {
      defaultOptions: {
        queries: {
          retry: false,
        },

        mutations: {
          retry: false,
        },
      },
    },
  }

  const container = document.createElement('div')
  const appChatId = Number(import.meta.env.VITE_MAIN_CHAT_ID)

  const app = createApp(App)

  app
    .use(router)
    .use(VueQueryPlugin, vueQueryPluginOptions)
    .provide(appTypeInjectionKey, 'embedded')
    .provide(appChatIdInjectionKey, appChatId)
    .mount(container)
}

main()
